import styled, { css } from 'styled-components'
import { FontIcon, tokens } from '@arvoreeducacao/bonsai-ds'
import { ContainerOnlyBigScreens } from 'styles/common/Common.styles'

const { colors, sizes, spacing } = tokens

interface ModalProps {
  show: boolean
}

interface ListItemProps {
  active?: boolean
  a11yEnabled?: boolean
}

export const ContainerOnlyBigScreensStyled = styled(ContainerOnlyBigScreens)`
  width: auto;
`

export const Modal = styled.div<ModalProps>`
  ${({ show }) =>
    !show
      ? css`
          display: none;
        `
      : ``}
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${colors.blackBg};
  z-index: 11;
  padding-top: 104px;
  padding-bottom: 120px;

  @media (max-width: ${sizes.mdScreen}px) {
    padding-top: 0px;
    padding-bottom: 0px;
    z-index: 12;
  }
`

export const ModalContent = styled.div`
  height: 100%;
  overflow: auto;
  display: flex;
  width: 840px;
  margin: auto;
  justify-content: space-between;

  @media (max-width: ${sizes.mdScreen}px) {
    width: 100%;
  }
`

export const BookBox = styled.div`
  width: 186px;
`

export const ChaptersBox = styled.div`
  width: 622px;

  @media (max-width: ${sizes.mdScreen}px) {
    width: 100%;
  }
`

export const BookCover = styled.img`
  max-width: 186px;
  border-radius: ${tokens.radius.large};
  filter: drop-shadow(0px 6px 10px rgba(0, 0, 0, 0.06));
`

export const Title = styled.h2`
  padding: 0;
  margin: 0 0 ${spacing.spacingMedium}px 0;

  @media (max-width: ${sizes.mdScreen}px) {
    padding: 0 ${spacing.spacingSmall}px 0 ${spacing.spacingSmall}px;
  }
`

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`

export const ListItem = styled.li<ListItemProps>`
  cursor: pointer;
  line-height: 28px;
  padding: 0 ${spacing.spacingSmall}px 9px ${spacing.spacingSmall}px;
  border-bottom: solid ${colors.black2} 1px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  text-transform: capitalize;

  color: ${({ active, a11yEnabled }) => {
    if (!active) return colors.black5
    return a11yEnabled ? colors.primary900 : colors.primary
  }};
`

export const ChapterTime = styled.span`
  margin-right: 22px;
`

export const CheckCircleFill = styled(FontIcon)`
  line-height: 28px;
  ${({ show }) =>
    !show &&
    css`
      visibility: hidden;
    `}
`

export const ChapterLeft = styled.div`
  display: flex;
  align-content: center;
`

export const ChapterRight = styled.div`
  justify-content: space-between;
  display: flex;
  align-content: center;
  margin-left: 16px;
`

export const CloseModal = styled.div`
  padding: 18px 20px 0 20px;
  display: flex;
  align-items: end;
  justify-content: end;
`
